import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {DataType, InputField} from '@models/sidebar/response/form-page';
import {TranslateService} from '@ngx-translate/core';
import {FormPageService} from '@services/left-menu/page/form-page/form-page.service';

@Component({
    selector: 'scitis-form-page-field',
    templateUrl: './form-page-field.component.html',
    styleUrls: ['./form-page-field.component.scss'],
    standalone: false
})
export class FormPageFieldComponent implements OnInit, OnChanges {

  @Input()
  inputField: InputField = new InputField();

  @Input()
  clearFormTrigger: boolean = false;

  @Output()
  inputFieldChange: EventEmitter<any> = new EventEmitter();

  addListItemText: string = '';
  isChecked: boolean = false;
  dropDownModel: any;
  startDate: string = '';
  startTime: any;
  listEntry: string = '';

  constructor(private translateService: TranslateService,
              private formPageService: FormPageService) {
    this.addListItemText = this.translateService.instant('Add list item');
  }

  get inputType(): string {
    return this.formPageService.getInputType(this.inputField);
  }

  get isCheckbox(): boolean {
    return this.inputField.datatype === DataType.BOOLEAN;
  }

  get isDate(): boolean {
    return this.inputField.datatype === DataType.TIMESTAMP;
  }

  get isInput(): boolean {
    return !this.inputField.dropdown && !this.inputField.list;
  }

  get isDropdown(): boolean {
    return this.inputField.dropdown;
  }

  get isMultipleDropdown(): boolean {
    return this.inputField.dropdown && this.inputField.list;
  }

  get isList(): boolean {
    return !this.inputField.dropdown && this.inputField.list;
  }

  get requiredField(): boolean {
    return this.inputField.required;
  }

  get isValueNotSet(): boolean {
    return !this.inputField.value || this.inputField.value.isNullOrWhitespace();
  }

  get isValueListNotSet(): boolean {
    return !this.inputField.valueList || this.inputField.valueList.length === 0;
  }

  private static getStartDate() {
    const now = new Date();
    return String(now.getTime());
  }

  private static getStartTime() {
    return {hour: 0, minute: 0, second: 0};
  }

  ngOnInit() {
    this.initializeCheckbox();
    this.initializeDate();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.clearFormTrigger) {
      this.listEntry = '';
      this.initializeCheckbox();
      this.initializeDropdown();
      this.initializeDate();
    }
  }

  setCheckboxRequiredStyle() {
    if (this.requiredField && !this.isChecked) {
      return {
        'outline': '2px solid red',
        'margin-left': '10px'
      };
    }
    return {'margin-left': '10px'};
  }

  onAddListItem(): void {
    if (!this.listEntry || this.listEntry.trim().length === 0) {
      return;
    }
    if (!this.inputField.valueList) {
      this.inputField.valueList = [];
    }
    this.inputField.valueList.push(this.listEntry);
    this.listEntry = '';
    this.onChangeInput();
  }

  onDeleteListItem(item: string): void {
    const index = this.inputField.valueList.indexOf(item);
    this.inputField.valueList.splice(index, 1);
    this.onChangeInput();
  }

  getInputClass() {
    if (!this.requiredField) {
      return '';
    }
    if ((this.isInput || this.isDropdown) && !this.inputField.list && !this.isCheckbox && this.isValueNotSet) {
      return 'is-invalid';
    }
    if (this.isCheckbox && this.isCheckboxInvalid()) {
      return 'is-invalid';
    }
    if ((this.isMultipleDropdown || this.isList) && this.isValueListNotSet) {
      return 'is-invalid';
    }
    return '';
  }

  setCheckboxValue() {
    this.inputField.value = String(this.isChecked);
    this.onChangeInput();
  }

  setDropdownValue() {
    if (this.isMultipleDropdown) {
      this.inputField.valueList = this.dropDownModel;
    } else {
      this.inputField.value = this.dropDownModel;
    }
    this.onChangeInput();
  }

  setInputFieldValue() {
    this.onChangeInput();
  }

  onFocusOutStartTime(event) {
    if (!event || !event.date || !event.time || event.time.hour === undefined || event.time.minute === undefined || event.time.second === undefined) {
      return;
    }
    const date = new Date(Number(event.date));

    date.setHours(Number(event.time.hour));
    date.setMinutes(Number(event.time.minute));
    date.setSeconds(Number(event.time.second));
    this.inputField.value = date.toISOString();
    this.onChangeInput();
  }

  private initializeDropdown() {
    if (!this.isDropdown) {
      return;
    }
    if (this.isMultipleDropdown) {
      this.dropDownModel = [];
    } else {
      this.dropDownModel = '';
    }
  }

  private initializeCheckbox() {
    if (this.isCheckbox) {
      this.inputField.value = 'false';
      this.isChecked = false;
    }
  }

  private initializeDate() {
    if (this.isDate) {
      this.startDate = FormPageFieldComponent.getStartDate();
      this.startTime = FormPageFieldComponent.getStartTime();
    }
  }

  private onChangeInput() {
    this.inputFieldChange.emit();
  }

  private isCheckboxInvalid() {
    if (this.requiredField) {
      return !this.isChecked;
    }
    return true;
  }
}
